require("./repayments.scss");
require("./repayments-right-panel.scss");
require("./_finance_disclaimer_modal.scss");

(function ($) {

  $(function () {
    $("[repayment-feature]").each(function () {
      const elm = $(this);
      const apiUrl = elm.data("apiUrl");

      $.get(apiUrl).done((data) => {
        if (data === "") {
          return;
        }
        
        elm.html(data);
        $('[data-toggle="tooltip"]').tooltip();
        if ($.fn.csnScroll) {
          $("[data-toggle='scroll']").csnScroll();
        }

        setTimeout(function () {
          elm.slideDown(); // show the finance element on the screen
        }, 500); // Give it some delay time for smooth animation, also attract attention

      });
    });
  });

})(jQuery);